import React from 'react';
import PropTypes from 'prop-types';
import { Stack, Button } from '@mui/material';
import ProtectedComponent from '../../../components/protected/ProtectedComponent';
import Iconify from '../../../components/iconify';

const Header = ({ onCreateClick }) => (
  <Stack direction="row" alignItems="center" justifyContent="flex-end" mb={2.5}>
    <ProtectedComponent permission={'CREATE_TEAM'}>
      <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />} onClick={onCreateClick}>
        New Team
      </Button>
    </ProtectedComponent>
  </Stack>
);

Header.propTypes = {
  onCreateClick: PropTypes.func,
};

export default Header;
